module.exports = __webpack_public_path__ + "static/img/7.7d1d53d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/7.jpg
// module id = BUTA
// module chunks = 0